import { useState, useEffect } from "react";
import { API_BASE_URL } from "../../../config";
import ListeningUnitCard from "./ListeningUnitCard";
import LoadingScreen from "../../common/LoadingScreen";
import { authFetch } from "../../../utils/auth";

// Group lessons by their sequence number (same sequence = same unit)
function groupByUnit(tiles) {
    const units = {};
    (tiles || []).forEach(tile => {
        const unit = tile.sequence;
        if (!units[unit]) units[unit] = [];
        units[unit].push(tile);
    });
    return units;
}

function ListeningDash({ tiles, lang_id }) {
    const [unitProgress, setUnitProgress] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (lang_id === undefined || lang_id === null) return;
        setLoading(true);
        authFetch(`${API_BASE_URL}/api/sual/units?lang_id=${lang_id}`)
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    setError(true);
                    console.error(data.error);
                    return;
                }
                const byUnit = {};
                (data.units || []).forEach(u => { byUnit[u.sequence] = u; });
                setUnitProgress(byUnit);
            })
            .catch(err => {
                console.error(err);
                setError(true);
            })
            .finally(() => setLoading(false));
    }, [lang_id]);

    const units = groupByUnit(tiles);

    return (
        <div className="listening-dash-container">
            {loading && (
                <LoadingScreen inline title="Loading units..." size={45} />
            )}

            {error && !loading && (
                <div className="listening-dash-error">
                    Could not load listening units. Please try again later.
                </div>
            )}

            {!loading && !error && (
                <div className="listening-units-grid">
                    {Object.keys(units).map((unitKey, idx) => {
                        const unitNum = parseInt(unitKey, 10);
                        const progress = (unitProgress && unitProgress[unitNum]) || {
                            practiced_count: 0,
                            new_word_count: 0,
                            familiarity_score: 0,
                        };
                        const locked = idx > 0 && !(unitProgress && unitProgress[unitNum - 1]?.practiced_count > 0);
                        const unitTitle = `Unit ${unitNum}`;

                        return (
                            <ListeningUnitCard
                                key={unitKey}
                                unitNumber={unitNum}
                                title={unitTitle}
                                wordCount={progress.new_word_count}
                                practicedCount={progress.practiced_count}
                                familiarity={progress.familiarity_score}
                                locked={locked}
                                onStart={() => {
                                    window.location.href = `/listening?unit=${unitNum}`;
                                }}
                            />
                        );
                    })}
                </div>
            )}
        </div>
    );
}

export default ListeningDash;
